import * as React from "react";
import type { SVGProps } from "react";
const SvgClickHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.29 3.71c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-1-1.01C4.32.9 3.68.9 3.29 1.29a.996.996 0 0 0 0 1.41l1 1v.01ZM18.5 9c-.31 0-.61.06-.89.17C17.17 8.47 16.39 8 15.5 8c-.31 0-.61.06-.89.17A2.492 2.492 0 0 0 12 7.05V4.5a2.5 2.5 0 0 0-5 0v6.12c-.93-.75-2.22-.85-3.26-.23-1.17.7-1.56 2.18-.89 3.37 2.55 4.53 3.11 5.47 3.32 5.79l.2.3a6.964 6.964 0 0 0 5.51 3.14h2.13c3.86 0 7-3.14 7-7v-4.5a2.5 2.5 0 0 0-2.5-2.5L18.5 9Zm.5 7c0 2.76-2.24 5-5 5h-1.79a4.96 4.96 0 0 1-4.17-2.25l-.2-.3c-.29-.45-1.39-2.36-3.25-5.67a.502.502 0 0 1 .18-.68c.34-.21.78-.15 1.06.13L7.3 13.7a1 1 0 0 0 1.09.22 1.019 1.019 0 0 0 .62-.92V4.5c0-.28.22-.5.5-.5s.5.22.5.5V12c0 .55.45 1 1 1s1-.45 1-1V9.5c0-.28.22-.5.5-.5s.5.22.5.5V12c0 .55.45 1 1 1s1-.45 1-1v-1.5c0-.28.22-.5.5-.5s.5.22.5.5V12c0 .55.45 1 1 1s1-.45 1-1v-.5c0-.28.22-.5.5-.5s.5.22.5.5V16H19ZM5 7c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1Zm9-3h.01H14Zm.005 0c.258-.001.506-.101.705-.29l1-1A.996.996 0 1 0 14.3 1.3l-1 1a.996.996 0 0 0 .705 1.7ZM14 6c0-.55.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.55 0-1-.45-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClickHand;
